var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page-search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95898 2.2915V17.7082H9.16732C9.5125 17.7082 9.79232 17.988 9.79232 18.3332C9.79232 18.6783 9.5125 18.9582 9.16732 18.9582H3.83398C3.21266 18.9582 2.70898 18.4545 2.70898 17.8332V2.1665C2.70898 1.54518 3.21267 1.0415 3.83398 1.0415H13.5435C13.8419 1.0415 14.1281 1.16003 14.339 1.37101L16.9628 3.99478C17.1738 4.20576 17.2923 4.49191 17.2923 4.79028V9.99984C17.2923 10.345 17.0125 10.6248 16.6673 10.6248C16.3221 10.6248 16.0423 10.345 16.0423 9.99984V4.84205L13.4918 2.2915H3.95898Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04232 4.99984C6.04232 4.65466 6.32214 4.37484 6.66732 4.37484H10.0007C10.3458 4.37484 10.6257 4.65466 10.6257 4.99984C10.6257 5.34502 10.3458 5.62484 10.0007 5.62484H6.66732C6.32214 5.62484 6.04232 5.34502 6.04232 4.99984ZM6.04232 8.33317C6.04232 7.98799 6.32214 7.70817 6.66732 7.70817H13.334C13.6792 7.70817 13.959 7.98799 13.959 8.33317C13.959 8.67835 13.6792 8.95817 13.334 8.95817H6.66732C6.32214 8.95817 6.04232 8.67835 6.04232 8.33317ZM6.04232 11.6665C6.04232 11.3213 6.32214 11.0415 6.66732 11.0415H9.16732C9.5125 11.0415 9.79232 11.3213 9.79232 11.6665C9.79232 12.0117 9.5125 12.2915 9.16732 12.2915H6.66732C6.32214 12.2915 6.04232 12.0117 6.04232 11.6665Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.642 16.6412C16.8861 16.3972 17.2818 16.3972 17.5259 16.6412L18.7759 17.8912C19.02 18.1353 19.02 18.531 18.7759 18.7751C18.5318 19.0192 18.1361 19.0192 17.892 18.7751L16.642 17.5251C16.398 17.281 16.398 16.8853 16.642 16.6412Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0007 13.1248C13.9651 13.1248 13.1257 13.9643 13.1257 14.9998C13.1257 16.0354 13.9651 16.8748 15.0007 16.8748C15.5195 16.8748 15.9881 16.6649 16.3282 16.3239C16.6672 15.984 16.8757 15.5169 16.8757 14.9998C16.8757 13.9643 16.0362 13.1248 15.0007 13.1248ZM11.8757 14.9998C11.8757 13.2739 13.2748 11.8748 15.0007 11.8748C16.7265 11.8748 18.1257 13.2739 18.1257 14.9998C18.1257 15.8611 17.7764 16.642 17.2133 17.2066C16.6482 17.7732 15.8649 18.1248 15.0007 18.1248C13.2748 18.1248 11.8757 16.7257 11.8757 14.9998Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 1.0415C13.6792 1.0415 13.959 1.32133 13.959 1.6665V4.37484H16.6673C17.0125 4.37484 17.2923 4.65466 17.2923 4.99984C17.2923 5.34502 17.0125 5.62484 16.6673 5.62484H13.834C13.2127 5.62484 12.709 5.12116 12.709 4.49984V1.6665C12.709 1.32133 12.9888 1.0415 13.334 1.0415Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageSearch);
export default __webpack_public_path__ + "static/media/page-search.b14f60a4423ff63ab412606c4d836c8b.svg";
export { ForwardRef as ReactComponent };